import React, { useEffect, useState } from "react";

import {
  bgrouplist,
  statemaster,
  stuacademicyearlist,
  stucastelist,
  stucategorylist,
  stuclasslist,
  studivisionlist,
  stumediumlist,
  stureligionlist,
  stusubcastelist,
  vehstagelist,
  vehtriplist,
  getStudentMasters,
} from "../../../services/master";
import Select from "react-select";
import { toast } from "react-toastify";
import {
  studentcountcheck,
  studentcreate,
  studentupdate,
  studentview,
} from "../../../services/student";
import { useLocation, useNavigate, useParams } from "react-router-dom";
import { phonevalidate } from "../../../services/common";
import { academylist, listvehicle } from "../../../services/admin";
import moment from "moment";
export default function Addstudents() {
  const navigate = useNavigate();
  const { id } = useParams();
  const [urllink, setUrllink] = useState("");
  const [sname, setSName] = useState("");
  const [gender, setGender] = useState("");
  const [dob, setDob] = useState("");
  const [bgroup, setBgroup] = useState("");
  const [blist, setBlist] = useState([]);

  const [pemail, setPEmail] = useState("");
  const [semail, setSEmail] = useState("");

  const [phone, setPhone] = useState("");
  const [aadno, setAadno] = useState("");
  const [emino, setEmino] = useState("");
  const [add1, setAdd1] = useState("");
  const [add2, setAdd2] = useState("");

  const [state, setState] = useState("");
  const [slist, setSlist] = useState([]);

  const [dist, setDist] = useState("");
  const [city, setCity] = useState("");
  const [pincode, setPincode] = useState("");
  const [pfile, setPFile] = useState("");
  const [purl, setPUrl] = useState("");

  const [fname, setFName] = useState("");
  const [mname, setMName] = useState("");
  const [gname, setGName] = useState("");

  const [email, setEmail] = useState("");
  const [pphone, setPPhone] = useState("");
  const [qual, setQual] = useState("");
  const [occu, setOccu] = useState("");
  const [aincome, setAIncome] = useState("");
  const [paddr, setPAddr] = useState("");

  const [cate, setCate] = useState("");
  const [clist, setCList] = useState([]);
  const [disc, setDisc] = useState("");

  const [srel, setSRel] = useState("");
  const [rlist, setRList] = useState([]);

  const [scaste, setSCaste] = useState("");
  const [sclist, setSCList] = useState([]);
  const [subcas, setSubCas] = useState("");
  const [sublist, setSubList] = useState([]);

  const [mtongue, setMTougue] = useState("");
  const [insname, setInsName] = useState("");
  const [premed, setPreMed] = useState("");
  const [mlist, setMList] = useState([]);
  const [tcno, setTCNo] = useState("");


  const [adate, setADate] = useState("");
  const [ayear, setAYear] = useState("");
  const [ylist, setYList] = useState([]);

  const [sclass, setSClass] = useState("");
  const [clslist, setClsList] = useState([]);
  const [studiv, setStuDiv] = useState("");
  const [divlist, setDivList] = useState([]);
  const [stutype, setStuType] = useState(1);

  const [admno, setAdmNo] = useState("");
  const [rollno, setRollNo] = useState("");

  const [alist, setAList] = useState([]);
  const [acaid, setAcaID] = useState("");

  const [vlist, setVList] = useState([]);
  const [vehid, setVehID] = useState("");

  const [stlist, setStList] = useState([]);
  const [stalllist, setStAllList] = useState([]); // all stages (with route_id) before vehicle filtering
  const [stgid, setStgID] = useState("");

  const [trlist, setTrList] = useState([]); // trips filtered to the selected vehicle
  const [tralllist, setTrAllList] = useState([]); // all trips before vehicle filtering
  const [tripsel, setTripSel] = useState([]); // selected trips (multi)

  const [username, setUserName] = useState("");
  const [pswd, setPswd] = useState("");

  let arr = [];

  function LetterOnly(eve) {
    if (/^[a-zA-Z\s]*$/.test(eve.key)) {
      return true;
    } else {
      eve.preventDefault();
      return false;
    }
  }

  function onPasteLetter(e) {
    const str = e.clipboardData.getData("Text");
    const newStr = str.replace(/[+-.]/g, "");
    if (str !== newStr) {
      e.preventDefault();
    }
  }
  const location = useLocation();

  useEffect(() => {
    setADate(moment(new Date()).format("YYYY-MM-DD"));

    const path = location.pathname.split("/")[2];
    setUrllink(path);
    listyear("");
    // All master dropdowns come from ONE cached combiner call (no parallel
    // burst). After the first load it is served from cache, so this page makes
    // ~zero master requests — avoids the shared-host process limit that caused
    // "SQLSTATE[HY000] [2002] Operation not permitted".
    getStudentMasters().then((m) => {
      setBlist(m.blood || []);
      setSlist((m.state || []).map((x) => ({ value: x.id, label: x.name })));
      setCList((m.category || []).map((x) => ({ value: x.id, label: x.cat_name })));
      setRList((m.religion || []).map((x) => ({ value: x.id, label: x.rel_name })));
      setSCList((m.caste || []).map((x) => ({ value: x.id, label: x.caste_name })));
      setSubList((m.subcaste || []).map((x) => ({ value: x.id, label: x.subcaste_name })));
      setMList(m.medium || []);
      setClsList((m.class || []).map((x) => ({ value: x.id, label: x.class_name })));
      setDivList((m.division || []).map((x) => ({ value: x.id, label: x.name })));
      setAList((m.academy || []).map((x) => ({ value: x.id, label: x.name + " - " + x.code })));
      listcheck(path, m);
    });
  }, [location.pathname]);

  function listcheck(ulink, m = {}) {
    if (ulink === "addstudents") {
      setSName("");
      setDob("");
      setGender("");
      setBgroup("");
      setPEmail("");
      setSEmail("");
      setPhone("");
      setAadno("");
      setAdd1("");
      setAdd2("");
      setState("");
      setDist("");
      setCity("");
      setPincode("");
      setEmino("");
      setFName("");
      setMName("");
      setGName("");
      setEmail("");
      setPPhone("");
      setOccu("");
      setQual("");
      setAIncome("");
      setPAddr("");
      setSCaste("");
      setDisc("");
      setSubCas("");
      setSRel("");
      setCate("");
      setMTougue("");
      setPreMed("");
      setInsName("");
      setTCNo("");
      setAYear("");
      setSClass("");
      setStuDiv("");
      setAdmNo("");
      setStuType(1);
      setRollNo("");
      setPUrl("");
      setUserName("");
      setPswd("");
      setVehID("");
      setStgID("");
      if (localStorage.getItem("ADate") !== '') {
        setADate(moment(localStorage.getItem("ADate")).format("YYYY-MM-DD"));
      } else {
        setADate(moment(new Date()).format("YYYY-MM-DD"));
      }

      if (localStorage.getItem("AAcademy") != null) {
        academylist().then((res) => {
          if (res.status === true) {
            let arr = [];
            if (res.data.details.length > 0) {
              for (let i = 0; i < res.data.details.length; i++) {
                if (res.data.details[i].id == localStorage.getItem("AAcademy")) {
                  arr.push({
                    value: res.data.details[i].id,
                    label:
                      res.data.details[i].name + " - " + res.data.details[i].code,
                  });
                }
                if (arr.length > 0) {
                  setAcaID(arr[0]);
                  listyear(arr[0]);
                  setAYear(localStorage.getItem("AYear"));
                }
              }

            }
          }
        });
      }
    } else {
      studentview(id, moment(new Date()).format("YYYY-MM-DD"), moment(new Date()).format("YYYY-MM-DD")).then(async (res) => {
        if (res.status === true) {
          setSName(res.data.details.student_name);
          setDob(res.data.details.date_of_birth);
          setGender(res.data.details.gender);
          if (res.data.details.bloodgroup !== null) {
            setBgroup(res.data.details.bloodgroup);
          }
          if (res.data.details.primary_email !== null) {
            setPEmail(res.data.details.primary_email);
          }
          if (res.data.details.secondary_email !== null) {
            setSEmail(res.data.details.secondary_email);
          }
          if (res.data.details.phone !== null) {
            setPhone(res.data.details.phone);
          }
          if (res.data.details.aadhar_no !== null) {
            setAadno(res.data.details.aadhar_no);
          }
          if (res.data.details.address1 !== null) {
            setAdd1(res.data.details.address1);
          }
          if (res.data.details.address2 !== null) {
            setAdd2(res.data.details.address2);
          }
          if (res.data.details.district !== null) {
            setDist(res.data.details.district);
          }
          if (res.data.details.city !== null) {
            setCity(res.data.details.city);
          }
          if (res.data.details.pincode !== null) {
            setPincode(res.data.details.pincode);
          }
          if (res.data.details.emis_no !== null) {
            setEmino(res.data.details.emis_no);
          }
          if (res.data.details.father_name !== null) {
            setFName(res.data.details.father_name);
          }
          if (res.data.details.mother_name !== null) {
            setMName(res.data.details.mother_name);
          }
          if (res.data.details.guardian_name !== null) {
            setGName(res.data.details.guardian_name);
          }
          if (res.data.details.parent_phone !== null) {
            setPPhone(res.data.details.parent_phone);
          }
          if (res.data.details.parent_email !== null) {
            setEmail(res.data.details.parent_email);
          }
          if (res.data.details.occupation !== null) {
            setOccu(res.data.details.occupation);
          }
          if (res.data.details.qualification !== null) {
            setQual(res.data.details.qualification);
          }
          if (res.data.details.annual_income !== null) {
            setAIncome(res.data.details.annual_income);
          }
          if (res.data.details.permanent_address !== null) {
            setPAddr(res.data.details.permanent_address);
          }
          if (res.data.details.mother_tongue !== null) {
            setMTougue(res.data.details.mother_tongue);
          }
          if (res.data.details.institute_name !== null) {
            setInsName(res.data.details.institute_name);
          }
          if (res.data.details.discount_per !== null) {
            setDisc(res.data.details.discount_per);
          }
          if (res.data.details.tc_number !== null) {
            setTCNo(res.data.details.tc_number);
          }
          if (res.data.details.admission_date !== null) {
            setADate(res.data.details.admission_date);
          }
          if (res.data.details.academicyear !== null) {
            setAYear(res.data.details.academicyear);
          }
          if (res.data.details.medium !== null) {
            setPreMed(res.data.details.medium);
          }
          if (res.data.details.admission_number !== null) {
            setAdmNo(res.data.details.admission_number);
          }
          if (res.data.details.resident_type !== null) {
            setStuType(res.data.details.resident_type);
          }
          if (res.data.details.roll_number !== null) {
            setRollNo(res.data.details.roll_number);
          }
          if (res.data.details.photo !== null) {
            setPUrl(res.data.path + res.data.details.photo);
            setPFile(res.data.path + res.data.details.photo);
          }
          if (res.data.details.username !== null) {
            setUserName(res.data.details.username);
          }

          if (res.data.password !== null) {
            setPswd(res.data.password);
          }


          // Selected values are resolved from the already-loaded cached master
          // lists (m) — NO extra network calls. This removes the duplicate burst
          // that exhausted the shared-host process limit (SQLSTATE[HY000] [2002]).
          const d = res.data.details;
          const findOpt = (list, id, labelKey) => {
            const hit = (list || []).find((x) => x.id == id);
            return hit ? { value: hit.id, label: hit[labelKey] } : "";
          };
          if (d.state_id)     setState(findOpt(m.state, d.state_id, "name"));
          if (d.stu_category) setCate(findOpt(m.category, d.stu_category, "cat_name"));
          if (d.stu_religion) setSRel(findOpt(m.religion, d.stu_religion, "rel_name"));
          if (d.stu_caste)    setSCaste(findOpt(m.caste, d.stu_caste, "caste_name"));
          if (d.stu_subcaste) setSubCas(findOpt(m.subcaste, d.stu_subcaste, "subcaste_name"));
          if (d.class_id)     setSClass(findOpt(m.class, d.class_id, "class_name"));
          if (d.section_id)   setStuDiv(findOpt(m.division, d.section_id, "name"));
          if (d.academy_id) {
            const aca = (m.academy || []).find((x) => x.id == d.academy_id);
            if (aca) setAcaID({ value: aca.id, label: aca.name + " - " + aca.code });
          }

          // Resolve this student's actual vehicle + stage, mirroring the add
          // flow: stages are limited to the selected vehicle's route(s).
          const temp = new FormData();
          temp.append("academy_id", res.data.details.academy_id);
          temp.append("status", 1);
          const rVeh = await listvehicle(temp);
          let vehRoute = "";
          let vehTrip = "";
          if (rVeh?.status === true && rVeh.data.details.length > 0) {
            const v = rVeh.data.details.find((x) => x.id == d.vehicle_id);
            if (v) {
              vehRoute = v.vehicle_route;
              vehTrip = v.vehicle_trip;
              setVehID({ value: v.id, label: v.vehicle_no + " - " + v.vehroute_name, route: v.vehicle_route, trip: v.vehicle_trip });
            }
          }

          // Resolve trips: limit to the vehicle's configured trips and preselect
          // the ones saved on this student (comma-separated trip_id).
          const rTrip = await vehtriplist(temp);
          if (rTrip?.status === true && rTrip.data?.length > 0) {
            const allTrips = rTrip.data.map((t) => ({
              value: t.id,
              label: t.vehtrip_name,
            }));
            setTrAllList(allTrips);
            const vTripIds = vehTrip
              ? String(vehTrip).split(",").map((x) => x.trim()).filter((x) => x !== "")
              : [];
            const filteredTrips = allTrips.filter((t) => vTripIds.includes(String(t.value)));
            setTrList(filteredTrips);
            const savedIds = d.trip_id
              ? String(d.trip_id).split(",").map((x) => x.trim()).filter((x) => x !== "")
              : [];
            setTripSel(filteredTrips.filter((t) => savedIds.includes(String(t.value))));
          }

          const temp1 = new FormData();
          temp1.append("academy_id", res.data.details.academy_id);
          const rStg = await vehstagelist(temp1);
          if (rStg?.status === true && rStg.data?.length > 0) {
            const allStages = rStg.data.map((s) => ({
              value: s.id,
              label: s.vehroute_stage,
              route_id: s.route_id,
            }));
            setStAllList(allStages);
            const ids = vehRoute
              ? String(vehRoute).split(",").map((x) => x.trim()).filter((x) => x !== "")
              : [];
            setStList(allStages.filter((s) => ids.includes(String(s.route_id))));
            const stg = allStages.find((s) => s.value == d.stage_id);
            if (stg) setStgID(stg);
          }
        }
      });
    }
  }
  const handleChange = (e) => {
    const regex = /^[0-9\b]+$/;
    if (e.target.value === "" || regex.test(e.target.value)) {
      setPhone(e.target.value);
    }
  };

  const [valmob, setValMob] = useState("");

  function checkphone(e) {
    e.preventDefault();
    setValMob("");
    if (urllink === "addstudents") {
      const temp = new FormData();
      temp.append("phone", e.target.value);
      temp.append("role", 4);
      phonevalidate(temp).then((response) => {
        if (response.status === false) {
          setValMob(response.message);
        }
      });
    }
  }

  const [valpemail, setValPEmail] = useState("");
  function checkpemail(e) {
    e.preventDefault();
    setValPEmail("");
    if (e.target.value !== "") {
      let regEmail = /^[^\s@]+@[^\s@]+\.[^\s@]{2,}$/i;
      if (!regEmail.test(e.target.value)) {
        setValPEmail("Please Enter a valid Email Address");
      }
    }
  }

  const [valsemail, setValSEmail] = useState("");
  function checksemail(e) {
    e.preventDefault();
    setValSEmail("");
    if (e.target.value !== "") {
      let regEmail = /^[^\s@]+@[^\s@]+\.[^\s@]{2,}$/i;
      if (!regEmail.test(e.target.value)) {
        setValSEmail("Please Enter a valid Email Address");
      }
    }
  }

  const [valemail, setValEmail] = useState("");
  function checkemail(e) {
    e.preventDefault();
    setValEmail("");
    if (e.target.value !== "") {
      let regEmail = /^[^\s@]+@[^\s@]+\.[^\s@]{2,}$/i;
      if (!regEmail.test(e.target.value)) {
        setValEmail("Please Enter a valid Email Address");
      }
    }
  }

  const handleAadhar = (e) => {
    const regex = /^[0-9\b]+$/;
    if (e.target.value === "" || regex.test(e.target.value)) {
      setAadno(e.target.value);
    }
  };

  const handlePincode = (e) => {
    const regex = /^[0-9\b]+$/;
    if (e.target.value === "" || regex.test(e.target.value)) {
      setPincode(e.target.value);
    }
  };

  const handleEmi = (e) => {
    const regex = /^[0-9\b]+$/;
    if (e.target.value === "" || regex.test(e.target.value)) {
      setEmino(e.target.value);
    }
  };

  const handlePhone = (e) => {
    const regex = /^[0-9\b]+$/;
    if (e.target.value === "" || regex.test(e.target.value)) {
      setPPhone(e.target.value);
    }
  };

  function handleState(e) {
    if (e !== null) {
      setState(e);
    } else {
      setState("");
    }
  }

  function handleCate(e) {
    if (e !== null) {
      setCate(e);
    } else {
      setCate("");
    }
  }
  function handleDisc(e) {
    const regex = /^[0-9\b]+$/;
    if (e.target.value === "" || regex.test(e.target.value)) {
      setDisc(e.target.value);
    }
  }

  function handleRel(e) {
    if (e !== null) {
      setSRel(e);
    } else {
      setSRel("");
    }
  }

  function handleCaste(e) {
    if (e !== null) {
      setSCaste(e);
    } else {
      setSCaste("");
    }
  }

  function handleSubCaste(e) {
    if (e !== null) {
      setSubCas(e);
    } else {
      setSubCas("");
    }
  }

  function handleClass(e) {
    if (e !== null) {
      setSClass(e);
    } else {
      setSClass("");
    }
  }

  function handleDiv(e) {
    if (e !== null) {
      setStuDiv(e);
    } else {
      setStuDiv("");
    }
  }

  function handleVehicle(e) {
    if (e !== null) {
      setVehID(e);
      // Limit stages to those on the selected vehicle's route(s). When the
      // vehicle has no route mapped, show no stages rather than all of them.
      const ids = e.route
        ? String(e.route).split(",").map((v) => v.trim()).filter((v) => v !== "")
        : [];
      setStList(stalllist.filter((s) => ids.includes(String(s.route_id))));
      setStgID("");
      // Limit trips to those configured on the selected vehicle.
      const tripIds = e.trip
        ? String(e.trip).split(",").map((v) => v.trim()).filter((v) => v !== "")
        : [];
      setTrList(tralllist.filter((t) => tripIds.includes(String(t.value))));
      setTripSel([]);
    } else {
      // No vehicle selected -> no stages or trips to choose from.
      setVehID("");
      setStList([]);
      setStgID("");
      setTrList([]);
      setTripSel([]);
    }
  }

  function handleStage(e) {
    if (e !== null) {
      setStgID(e);
    } else {
      setStgID("");
    }
  }

  function handleTrip(e) {
    setTripSel(e || []);
  }

  const [photoerror, setPhotoError] = useState("");
  function photofile(event) {
    setPhotoError("");
    setPFile("");
    if (event.target.files.length !== 0) {
      if (event.target.files[0].name.match(/\.(jpg|jpeg|png)$/i)) {
        setPUrl(URL.createObjectURL(event.target.files[0]));
        setPFile(event.target.files[0]);
      } else {
        setPhotoError("Photo should be jpg, jpeg, or png format");
      }
      var size = event.target.files[0].size / 1024 / 1024;
      if (size > 5) {
        setPhotoError("Photo size should be less than 5MB");
      }
    }
  }

  function errorphoto(ev) {
    ev.target.src = require("../../../assets/images/user.png");
    ev.target.onerror = null;
  }

  const [errmsg, setError] = useState("");
  const [successmsg, setSuccess] = useState(false);
  function submitstu(e) {
    e.preventDefault();
    setSuccess(true);
    var valid = "";
    if (phone !== "") {
      if (phone.length < 10) {
        valid = "Phone Number should be 10 digits";
        setError("Phone Number should be 10 digits");
      }
    }
    if (aadno !== "") {
      if (aadno.length < 12) {
        valid = "Aadhar Number should be 12 digits";
        setError("Aadhar Number should be 12 digits");
      }
    }

    if (pincode !== "") {
      if (pincode.length < 6) {
        valid = "Pincode should be 6 digits";
        setError("Pincode should be 6 digits");
      }
    }

    if (pphone !== "") {
      if (pphone.length < 10) {
        valid = "Parent's Phone Number should be 10 digits";
        setError("Parent's Phone Number should be 10 digits");
      }
    }

    if (email !== "") {
      let regEmail = /^[^\s@]+@[^\s@]+\.[^\s@]{2,}$/i;
      if (!regEmail.test(email)) {
        valid = "Please Enter a valid Email";
        setError("Please Enter a valid Email");
      }
    }

    if (localStorage.getItem("Role") === "1") {
      if (acaid === "") {
        setError("Please Select Academy");
        valid = "Please Select Academy";
      }
    } else {
      valid = "";
    }

    if (
      valid === "" &&
      sname !== "" &&
      gender !== "" &&
      // dob !== "" &&
      // bgroup !== "" &&
      // phone !== "" &&
      // aadno !== "" &&
      // add1 !== "" &&
      state !== "" &&
      dist !== "" &&
      city !== "" &&
      pincode !== "" &&
      // emino !== "" &&
      (fname !== "" || gname !== "") &&
      // email !== "" &&
      // pphone !== "" &&
      adate !== "" &&
      ayear !== "" &&
      sclass !== "" &&
      studiv !== "" &&
      admno !== "" &&
      rollno !== "" &&
      valmob === "" &&
      valpemail === "" &&
      valsemail === "" &&
      valemail === ""
    ) {
      setLoading(true);

      const temp = new FormData();
      temp.append("name", sname);
      temp.append("gender", gender);
      temp.append("dob", dob);
      temp.append("blood", bgroup);
      temp.append("primary_email", pemail);
      temp.append("secondary_email", semail);
      temp.append("mobile", phone);
      temp.append("emisno", emino);
      temp.append("aadhar", aadno);
      temp.append("add1", add1);
      temp.append("add2", add2);
      temp.append("state", state.value);
      temp.append("district", dist);
      temp.append("city", city);
      temp.append("pincode", pincode);
      temp.append("father", fname);
      temp.append("mother", mname);
      temp.append("guardian", gname);
      temp.append("parent_mobile", pphone);
      temp.append("parent_email", email);
      temp.append("occupation", occu);
      temp.append("qualification", qual);
      temp.append("income", aincome);
      temp.append("permanent_address", paddr);
      if (cate !== "") {
        temp.append("category", cate.value);
      } else {
        temp.append("category", "");
      }
      if (disc !== "") {
        temp.append("discount_per", disc);
      } else {
        temp.append("discount_per", "");
      }

      if (scaste !== "") {
        temp.append("caste", scaste.value);
      } else {
        temp.append("caste", "");
      }

      if (subcas !== "") {
        temp.append("subcaste", subcas.value);
      } else {
        temp.append("subcaste", "");
      }
      if (srel !== "") {
        temp.append("religion", srel.value);
      } else {
        temp.append("religion", "");
      }

      temp.append("mother_tongue", mtongue);
      temp.append("ins_name", insname);
      temp.append("medium", premed);
      temp.append("tc_no", tcno);
      temp.append("adm_date", adate);
      temp.append("year", ayear);
      temp.append("class", sclass.value);
      temp.append("section", studiv.value);
      temp.append("adm_number", admno);
      temp.append("roll_no", rollno);
      temp.append("photo", pfile);
      temp.append("resident_type", stutype);
      if (vehid !== "") {
        temp.append("vehicle_id", vehid.value);
      } else {
        temp.append("vehicle_id", "");
      }
      if (stgid !== "") {
        temp.append("stage_id", stgid.value);
      } else {
        temp.append("stage_id", "");
      }
      temp.append("trip_id", (tripsel || []).map((t) => t.value).join(","));
      temp.append("user_id", localStorage.getItem("UID"));
      if (localStorage.getItem("Role") === "1" && acaid !== "") {
        temp.append("academy", acaid.value);
      }
      if (urllink === "addstudents") {
        studentcreate(temp).then((res) => {
          if (res.status === true) {
            setLoading(false);
            toast.success(res.message);
            navigate("/student/allstudent");
          } else {
            setLoading(false);
            toast.error(res.message);
          }
        });
      } else {
        temp.append("id", id);
        studentupdate(temp).then((res) => {
          if (res.status === true) {
            setLoading(false);
            toast.success(res.message);
            navigate("/student/allstudent");
          } else {
            setLoading(false);
            toast.error(res.message);
          }
        });
      }
    }
  }

  function handleAcademy(e) {
    if (e !== null) {
      const temp = new FormData();
      temp.append("academy", e.value);
      studentcountcheck(temp).then((res) => {
        if (res.status === false) {
          toast.error(res.message);
        } else {
          setAcaID(e);
        }
      });
      listyear(e);
    } else {
      setAcaID("");
      listyear("");
    }
  }
  function listyear(aid) {
    setYList([]);
    setAYear("");
    setVList([]);
    setVehID("");
    setStList([]);
    setStAllList([]);
    setStgID("");

    const temp = new FormData();
    if (localStorage.getItem("Role") === "1" && aid !== "") {
      temp.append("academy_id", aid.value);
    }
    stuacademicyearlist(temp).then((res) => {
      if (res.status === true) {
        setYList(res.data);
      }
    });


    temp.append("status", 1);
    listvehicle(temp).then((response) => {
      if (response.status === true) {
        let arr = [];
        if (response.data.details.length > 0) {
          for (let i = 0; i < response.data.details.length; i++) {
            arr.push({
              value: response.data.details[i].id,
              label: response.data.details[i].vehicle_no + " - " + response.data.details[i].vehroute_name,
              route: response.data.details[i].vehicle_route,
              trip: response.data.details[i].vehicle_trip,
            });
          }
          setVList(arr);
        }
      }
    });

    const temptrip = new FormData();
    if (localStorage.getItem("Role") === "1" && aid !== "") {
      temptrip.append("academy_id", aid.value);
    }
    vehtriplist(temptrip).then((response) => {
      if (response.status === true) {
        const arr = (response.data || []).map((t) => ({
          value: t.id,
          label: t.vehtrip_name,
        }));
        setTrAllList(arr);
        // Trips stay empty until a vehicle is picked; they're then filtered
        // to the selected vehicle's configured trips in handleVehicle.
        setTrList([]);
      }
    });

    const temp1 = new FormData();
    if (localStorage.getItem("Role") === "1" && aid !== "") {
      temp1.append("academy_id", aid.value);
    }
    vehstagelist(temp1).then((response) => {
      if (response.status === true) {
        let arr = [];
        if (response.data.length > 0) {
          for (let i = 0; i < response.data.length; i++) {
            arr.push({
              value: response.data[i].id,
              label: response.data[i].vehroute_stage,
              route_id: response.data[i].route_id,
            });
          }
        }
        setStAllList(arr);
        // Stages stay empty until a vehicle is picked; they're then filtered
        // to the selected vehicle's route(s) in handleVehicle.
        setStList([]);
      }
    });

  }

  const [loading, setLoading] = useState(false);
  return (
    <div>
      <div className="page-header">
        {urllink === "addstudents" && (
          <>
            <h2 className="main-content-title tx-24 mg-b-5">Add Students</h2>
            <ol className="breadcrumb">
              <li className="breadcrumb-item">
                <a>Students</a>
              </li>
              <li className="breadcrumb-item active" aria-current="page">
                Add Students
              </li>
            </ol>
          </>
        )}

        {urllink !== "addstudents" && (
          <>
            <h2 className="main-content-title tx-24 mg-b-5">
              Students Details
            </h2>
            <ol className="breadcrumb">
              <li className="breadcrumb-item">
                <a>Students</a>
              </li>
              <li className="breadcrumb-item active" aria-current="page">
                Students Details
              </li>
            </ol>
          </>
        )}
      </div>

      {loading && (
        <div className="loader-wrapper">
          <div className="loader"></div>
          <h3>Loading...Please do not go back or close the window.</h3>
        </div>
      )}

      {!loading && (
        <div className="content-body">
          <div className="container-fluid">
            <div className="row">
              <div className="col-xl-12">
                <div className="card">
                  <div className="card-header">
                    <h2 className="main-content-title tx-24 mg-b-5">
                      Add Student Details
                    </h2>
                  </div>
                  <div className="card-body">
                    <div className="row">
                      <div className="col-xl-3 col-lg-4">
                        <label className="form-label">Photo</label>
                        <div className="avatar-upload">
                          <div className="avatar-preview">
                            <img
                              src={purl}
                              onError={(e) => errorphoto(e)}
                              alt="Student"
                            />
                          </div>
                          <div className="change-btn mt-2 mb-lg-0 mb-3">
                            <input
                              type="file"
                              className="form-control"
                              accept=".png, .jpg, .jpeg"
                              onChange={(e) => photofile(e)}
                            />
                            {photoerror !== "" && (
                              <span className="text-danger">{photoerror}</span>
                            )}

                            <a
                              className="btn btn-secondary my-2"
                              onClick={() => {
                                setPUrl("");
                                setPFile("");
                              }}
                            >
                              Remove
                            </a>
                          </div>
                        </div>


                      </div>
                      <div className="col-xl-9 col-lg-8">
                        <div className="row">
                          <div className="col-xl-6 col-sm-6">
                            <div className="mb-3">
                              <label className="form-label">
                                Student Name
                                <span className="text-danger"> *</span>
                              </label>
                              <input
                                type="text"
                                className="form-control"
                                placeholder="Enter Student Name"
                                value={sname}
                                onChange={(e) => setSName(e.target.value)}
                                onKeyPress={LetterOnly}
                                onPaste={onPasteLetter}
                              />
                              {successmsg && sname === "" && (
                                <span className="text-danger">
                                  Please Enter Student Name
                                </span>
                              )}
                            </div>
                          </div>
                          <div className="col-xl-6 col-sm-6">
                            <div className="mb-3">
                              <label className="form-label">
                                Date Of Birth
                                {/* <span className="text-danger"> *</span> */}
                              </label>
                              <input
                                className="form-control"
                                type="date"
                                value={dob}
                                onChange={(e) => setDob(e.target.value)}
                                onKeyPress={(event) => {
                                  event.preventDefault();
                                }}
                                onKeyDown={(event) => {
                                  event.preventDefault();
                                }}
                              />
                              {/*  {successmsg && dob === "" && (
                                <span className="text-danger">
                                  Please Enter Date Of Birth
                                </span>
                              )}*/}
                            </div>
                          </div>
                          {urllink === "addstudents" && (
                            <div className="col-xl-6 col-sm-6">
                              <div className="mb-3">
                                <label className="form-label">
                                  Gender<span className="text-danger"> *</span>
                                </label>
                                <select
                                  className="default-select  form-control wide"
                                  value={gender}
                                  onChange={(e) => setGender(e.target.value)}
                                >
                                  <option value="" disabled>
                                    Select Student Gender
                                  </option>
                                  <option value={"Male"}>Male</option>
                                  <option value={"Female"}>Female</option>
                                  <option value={"Others"}>Others</option>
                                </select>
                                {successmsg && gender === "" && (
                                  <span className="text-danger">
                                    Please Select Gender
                                  </span>
                                )}
                              </div>
                            </div>
                          )}
                          {urllink !== "addstudents" && (
                            <div className="col-xl-6 col-sm-6">
                              <div className="mb-3">
                                <label className="form-label">
                                  Gender<span className="text-danger"> *</span>
                                </label>
                                <select
                                  className="default-select  form-control wide"
                                  value={gender}
                                  onChange={(e) => setGender(e.target.value)}
                                  disabled
                                >
                                  <option value="" disabled>
                                    Select Student Gender
                                  </option>
                                  <option value={"Male"}>Male</option>
                                  <option value={"Female"}>Female</option>
                                  <option value={"Others"}>Others</option>
                                </select>
                                {successmsg && gender === "" && (
                                  <span className="text-danger">
                                    Please Select Gender
                                  </span>
                                )}
                              </div>
                            </div>
                          )}

                          <div className="col-xl-6 col-sm-6">
                            <div className="mb-3">
                              <label className="form-label">
                                Blood Group
                                {/* <span className="text-danger"> *</span> */}
                              </label>
                              <select
                                className="default-select  form-control wide"
                                value={bgroup}
                                onChange={(e) => setBgroup(e.target.value)}
                              >
                                <option value="" disabled>
                                  Select Blood Group
                                </option>
                                {blist.map((data, i) => {
                                  return (
                                    <option value={data.id} key={i}>
                                      {data.name}
                                    </option>
                                  );
                                })}
                              </select>
                              {/* {successmsg && bgroup === "" && (
                                <span className="text-danger">
                                  Please Select Blood Group
                                </span>
                              )} */}
                            </div>
                          </div>
                          <div className="col-xl-6 col-sm-6">
                            <div className="mb-3">
                              <label className="form-label">
                                Primary E-Mail
                              </label>
                              <input
                                type="text"
                                className="form-control"
                                placeholder="Enter Primary E-Mail"
                                value={pemail}
                                onChange={(e) => setPEmail(e.target.value)}
                                onBlur={checkpemail}
                                onPaste={(e) => {
                                  e.preventDefault();
                                  return false;
                                }}
                                onCopy={(e) => {
                                  e.preventDefault();
                                  return false;
                                }}
                              />
                              {valpemail !== "" && pemail && (
                                <span className="text-danger">{valpemail}</span>
                              )}
                            </div>
                          </div>
                          <div className="col-xl-6 col-sm-6">
                            <div className="mb-3">
                              <label className="form-label">
                                Secondary E-Mail
                              </label>
                              <input
                                type="text"
                                className="form-control"
                                placeholder="Enter Secondary E-Mail"
                                value={semail}
                                onChange={(e) => setSEmail(e.target.value)}
                                onBlur={checksemail}
                                onPaste={(e) => {
                                  e.preventDefault();
                                  return false;
                                }}
                                onCopy={(e) => {
                                  e.preventDefault();
                                  return false;
                                }}
                              />
                              {valsemail !== "" && semail && (
                                <span className="text-danger">{valsemail}</span>
                              )}
                            </div>
                          </div>
                          {urllink === "addstudents" && (
                            <div className="col-xl-6 col-sm-6">
                              <div className="mb-3">
                                <label className="form-label">
                                  Phone Number
                                  {/* <span className="text-danger"> *</span> */}
                                </label>
                                <input
                                  type="text"
                                  className="form-control"
                                  placeholder="Enter Phone Number"
                                  onChange={handleChange}
                                  onBlur={checkphone}
                                  value={phone}
                                  maxLength={10}
                                  onPaste={(e) => {
                                    e.preventDefault();
                                    return false;
                                  }}
                                  onCopy={(e) => {
                                    e.preventDefault();
                                    return false;
                                  }}
                                />
                                {valmob !== "" && phone && (
                                  <span className="text-danger">{valmob}</span>
                                )}
                                {/* {successmsg && phone === "" && (
                                  <span className="text-danger">
                                    Please Enter Phone Number
                                  </span>
                                )} */}
                              </div>
                            </div>
                          )}
                          {urllink !== "addstudents" && (
                            <div className="col-xl-6 col-sm-6">
                              <div className="mb-3">
                                <label className="form-label">
                                  Phone Number
                                  {/* <span className="text-danger"> *</span> */}
                                </label>
                                <input
                                  type="text"
                                  className="form-control"
                                  placeholder="Enter Phone Number"
                                  onChange={handleChange}
                                  value={phone}
                                  maxLength={10}
                                  onPaste={(e) => {
                                    e.preventDefault();
                                    return false;
                                  }}
                                  onCopy={(e) => {
                                    e.preventDefault();
                                    return false;
                                  }}
                                // disabled
                                />
                                {/* {successmsg && phone === "" && (
                                  <span className="text-danger">
                                    Please Enter Phone Number
                                  </span>
                                )} */}
                              </div>
                            </div>
                          )}
                          <div className="col-xl-6 col-sm-6">
                            <div className="mb-3">
                              <label className="form-label">
                                Aadhar Number
                                {/* <span className="text-danger"> *</span> */}
                              </label>
                              <input
                                type="text"
                                className="form-control"
                                placeholder="Enter Aadhar Number"
                                maxLength={12}
                                value={aadno}
                                onChange={handleAadhar}
                                onPaste={(e) => {
                                  e.preventDefault();
                                  return false;
                                }}
                                onCopy={(e) => {
                                  e.preventDefault();
                                  return false;
                                }}
                              />
                              {/* {successmsg && aadno === "" && (
                                <span className="text-danger">
                                  Please Enter Aadhar Number
                                </span>
                              )} */}
                            </div>
                          </div>
                          <div className="col-xl-6 col-sm-6">
                            <div className="mb-3">
                              <label className="form-label">
                                {/* Address 1<span className="text-danger"> *</span> */}
                              </label>
                              <input
                                type="text"
                                className="form-control"
                                placeholder="Enter Address 1"
                                value={add1}
                                onChange={(e) => setAdd1(e.target.value)}
                              />
                              {/* {successmsg && add1 === "" && (
                                <span className="text-danger">
                                  Please Enter Address 1
                                </span>
                              )} */}
                            </div>
                          </div>
                          <div className="col-xl-6 col-sm-6">
                            <div className="mb-3">
                              <label className="form-label">
                                Address Line 2
                              </label>
                              <input
                                type="text"
                                className="form-control"
                                placeholder="Enter Address Line 2"
                                value={add2}
                                onChange={(e) => setAdd2(e.target.value)}
                              />
                            </div>
                          </div>
                          <div className="col-xl-6 col-sm-6">
                            <div className="mb-3">
                              <label className="form-label">
                                State<span className="text-danger"> *</span>
                              </label>
                              <Select
                                className="default-select"
                                placeholder="Select State"
                                value={state}
                                options={slist}
                                onChange={handleState}
                                isSearchable={true}
                                isClearable
                                hidden
                              />

                              {successmsg && state === "" && (
                                <span className="text-danger">
                                  Please Select State
                                </span>
                              )}
                            </div>
                          </div>
                          <div className="col-xl-6 col-sm-6">
                            <div className="mb-3">
                              <label className="form-label">
                                District<span className="text-danger"> *</span>
                              </label>
                              <input
                                type="text"
                                className="form-control"
                                placeholder="Enter District"
                                value={dist}
                                onChange={(e) => setDist(e.target.value)}
                              />
                              {successmsg && dist === "" && (
                                <span className="text-danger">
                                  Please Enter District
                                </span>
                              )}
                            </div>
                          </div>
                          <div className="col-xl-6 col-sm-6">
                            <div className="mb-3">
                              <label className="form-label">
                                City<span className="text-danger"> *</span>
                              </label>
                              <input
                                type="text"
                                className="form-control"
                                placeholder="Enter Your City / Thaluk"
                                value={city}
                                onChange={(e) => setCity(e.target.value)}
                              />
                              {successmsg && city === "" && (
                                <span className="text-danger">
                                  Please Enter City
                                </span>
                              )}
                            </div>
                          </div>
                          <div className="col-xl-6 col-sm-6">
                            <div className="mb-3">
                              <label className="form-label">
                                Pincode<span className="text-danger"> *</span>
                              </label>
                              <input
                                type="text"
                                className="form-control"
                                placeholder="Enter Pincode"
                                maxLength={6}
                                value={pincode}
                                onChange={handlePincode}
                              />
                              {successmsg && pincode === "" && (
                                <span className="text-danger">
                                  Please Enter Pincode
                                </span>
                              )}
                            </div>
                          </div>
                          <div className="col-xl-6 col-sm-6">
                            <div className="mb-3">
                              <label className="form-label">
                                EMIS No
                                {/* <span className="text-danger"> *</span> */}
                              </label>
                              <input
                                type="text"
                                className="form-control"
                                placeholder="Enter EMIS Number"
                                onChange={handleEmi}
                                value={emino}
                              />
                              {/* {successmsg && emino === "" && (
                                <span className="text-danger">
                                  Please Enter EMIS Number
                                </span>
                              )} */}
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div className="col-xl-12 mt-2">
                <div className="card">
                  <div className="card-header">
                    <h2 className="main-content-title tx-24 mg-b-5">
                      Add Parents Details
                    </h2>
                  </div>
                  <div className="card-body">
                    <div className="row">
                      <div className="col-xl-6 col-sm-6">
                        <div className="mb-3">
                          <label className="form-label">
                            Father Name
                            <span className="text-danger"> *</span>
                          </label>
                          <input
                            type="text"
                            className="form-control"
                            placeholder="Enter Father Name"
                            value={fname}
                            onChange={(e) => setFName(e.target.value)}
                            onKeyPress={LetterOnly}
                            onPaste={onPasteLetter}
                          />
                          {successmsg && fname === "" && gname === "" && (
                            <span className="text-danger">
                              Please Enter Father or Guardian Name
                            </span>
                          )}
                        </div>
                      </div>
                      <div className="col-xl-6 col-sm-6">
                        <div className="mb-3">
                          <label className="form-label">Mother Name</label>
                          <input
                            type="text"
                            className="form-control"
                            placeholder="Enter Mother Name"
                            value={mname}
                            onChange={(e) => setMName(e.target.value)}
                            onKeyPress={LetterOnly}
                            onPaste={onPasteLetter}
                          />
                        </div>
                      </div>
                      <div className="col-xl-6 col-sm-6">
                        <div className="mb-3">
                          <label className="form-label">
                            Guardian Name{" "}
                            <span className="text-danger"> *</span>
                          </label>
                          <input
                            type="text"
                            className="form-control"
                            placeholder="Enter Guardian Name"
                            value={gname}
                            onChange={(e) => setGName(e.target.value)}
                            onKeyPress={LetterOnly}
                            onPaste={onPasteLetter}
                          />
                          {successmsg && gname === "" && fname === "" && (
                            <span className="text-danger">
                              Please Enter Father or Guardian Name
                            </span>
                          )}
                        </div>
                      </div>
                      <div className="col-xl-6 col-sm-6">
                        <div className="mb-3">
                          <label className="form-label">
                            Parent's Phone Number
                            {/* <span className="text-danger"> *</span> */}
                          </label>
                          <input
                            type="text"
                            className="form-control"
                            maxLength={10}
                            placeholder="Enter Parent's Phone Number"
                            value={pphone}
                            onChange={handlePhone}
                          />
                          {/* {successmsg && pphone === "" && (
                            <span className="text-danger">
                              Please Enter Parent's Phone Number
                            </span>
                          )} */}
                        </div>
                      </div>
                      <div className="col-xl-6 col-sm-6">
                        <div className="mb-3">
                          <label className="form-label">
                            Parent E-Mail{" "}
                            {/* <span className="text-danger"> *</span> */}
                          </label>
                          <input
                            type="text"
                            className="form-control"
                            placeholder="Enter Parent E-Mail"
                            value={email}
                            onChange={(e) => setEmail(e.target.value)}
                            onBlur={checkemail}
                            onPaste={(e) => {
                              e.preventDefault();
                              return false;
                            }}
                            onCopy={(e) => {
                              e.preventDefault();
                              return false;
                            }}
                          />
                          {/* {successmsg && email === "" && (
                            <span className="text-danger">
                              Please Enter Parent E-Mail
                            </span>
                          )} */}
                          {valemail !== "" && email && (
                            <span className="text-danger">{valemail}</span>
                          )}
                        </div>
                      </div>
                      <div className="col-xl-6 col-sm-6">
                        <div className="mb-3">
                          <label className="form-label">Occupation</label>
                          <input
                            type="text"
                            className="form-control"
                            placeholder="Enter Occupation"
                            value={occu}
                            onChange={(e) => setOccu(e.target.value)}
                          />
                        </div>
                      </div>
                      <div className="col-xl-6 col-sm-6">
                        <div className="mb-3">
                          <label className="form-label">Qualification</label>
                          <input
                            type="text"
                            className="form-control"
                            placeholder="Enter Qualification"
                            value={qual}
                            onChange={(e) => setQual(e.target.value)}
                          />
                        </div>
                      </div>
                      <div className="col-xl-6 col-sm-6">
                        <div className="mb-3">
                          <label className="form-label">Annual Income</label>
                          <input
                            type="text"
                            className="form-control"
                            placeholder="Enter Annual Income"
                            value={aincome}
                            onChange={(e) => setAIncome(e.target.value)}
                          />
                        </div>
                      </div>
                      <div className="col-xl-6 col-sm-6">
                        <div className="mb-3">
                          <label className="form-label">
                            Permanent Address
                          </label>
                          <textarea
                            rows={3}
                            className="form-control"
                            placeholder="Enter your Permanent Address"
                            value={paddr}
                            onChange={(e) => setPAddr(e.target.value)}
                          />
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <div className="row mt-2">
              <div className="col-xl-12">
                <div className="card">
                  <div className="card-header">
                    <h2 className="main-content-title tx-24 mg-b-5">
                      Student Other Details
                    </h2>
                  </div>
                  <div className="card-body">
                    <div className="row">
                      <div className="col-xl-6 col-sm-6">
                        <div className="mb-3">
                          <label className="form-label">Student Category</label>
                          <Select
                            className="default-select"
                            placeholder="Select Student Category"
                            value={cate}
                            options={clist}
                            onChange={handleCate}
                            isSearchable={true}
                            isClearable
                            hidden
                          />
                        </div>
                      </div>
                      <div className="col-xl-6 col-sm-6">
                        <div className="mb-3">
                          <label className="form-label">
                            Student Discount for Fees (Rs)
                          </label>
                          <input
                            type="text"
                            className="form-control"
                            placeholder="Enter Student Discount for Fees"
                            value={disc}
                            onChange={handleDisc}
                            maxLength={6}
                          />
                        </div>
                      </div>
                      <div className="col-xl-6 col-sm-6">
                        <div className="mb-3">
                          <label className="form-label">Student Religion</label>
                          <Select
                            className="default-select"
                            placeholder="Select Student Religion"
                            value={srel}
                            options={rlist}
                            onChange={handleRel}
                            isSearchable={true}
                            isClearable
                            hidden
                          />
                        </div>
                      </div>
                      <div className="col-xl-6 col-sm-6">
                        <div className="mb-3">
                          <label className="form-label">Student Caste</label>
                          <Select
                            className="default-select"
                            placeholder="Select Student Caste"
                            value={scaste}
                            options={sclist}
                            onChange={handleCaste}
                            isSearchable={true}
                            isClearable
                            hidden
                          />
                        </div>
                      </div>
                      <div className="col-xl-6 col-sm-6">
                        <div className="mb-3">
                          <label className="form-label">
                            Student Sub Caste
                          </label>
                          <Select
                            className="default-select"
                            placeholder="Select Student Sub Caste"
                            value={subcas}
                            options={sublist}
                            onChange={handleSubCaste}
                            isSearchable={true}
                            isClearable
                            hidden
                          />
                        </div>
                      </div>
                      <div className="col-xl-6 col-sm-6">
                        <div className="mb-3">
                          <label className="form-label">Mother Tongue</label>
                          <input
                            type="text"
                            className="form-control"
                            placeholder="Enter Mother Tongue"
                            value={mtongue}
                            onChange={(e) => setMTougue(e.target.value)}
                            onKeyPress={LetterOnly}
                            onPaste={onPasteLetter}
                          />
                        </div>
                      </div>
                      <div className="col-xl-6 col-sm-6">
                        <div className="mb-3">
                          <label className="form-label">
                            Previous Institute Name
                          </label>
                          <input
                            type="text"
                            className="form-control"
                            placeholder="Enter Previous Institute Name"
                            value={insname}
                            onChange={(e) => setInsName(e.target.value)}
                            onKeyPress={LetterOnly}
                            onPaste={onPasteLetter}
                          />
                        </div>
                      </div>
                      <div className="col-xl-6 col-sm-6">
                        <div className="mb-3">
                          <label className="form-label">Previous Medium</label>
                          <select
                            className="default-select  form-control wide"
                            value={premed}
                            onChange={(e) => setPreMed(e.target.value)}
                          >
                            <option value="" disabled>
                              Select Previous Medium
                            </option>
                            {mlist.map((item, i) => {
                              return (
                                <option value={item.id} key={i}>
                                  {item.medium_name}
                                </option>
                              );
                            })}
                          </select>
                        </div>
                      </div>
                      <div className="col-xl-6 col-sm-6">
                        <div className="mb-3">
                          <label className="form-label">
                            Previous TC Number
                          </label>
                          <input
                            type="text"
                            className="form-control"
                            placeholder="Enter Previous TC Number"
                            value={tcno}
                            onChange={(e) => setTCNo(e.target.value)}
                          />
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div className="col-xl-12">
                <div className="card">
                  <div className="card-header">
                    <h2 className="main-content-title tx-24 mg-b-5">
                      Student Admission Details
                    </h2>
                  </div>
                  <div className="card-body">
                    <div className="row">
                      {localStorage.getItem("Role") === "1" && (
                        <div className="col-xl-6 col-sm-6">
                          <div className="mb-3">
                            <label className="form-label ">
                              Select Academy
                              <span className="text-danger"> *</span>
                            </label>
                            <Select
                              className="default-select"
                              placeholder="Select Academy"
                              value={acaid}
                              options={alist}
                              onChange={handleAcademy}
                              isSearchable={true}
                              isClearable
                              hidden
                            />
                            {successmsg && acaid === "" && (
                              <span className="text-danger">
                                Please Select Academy
                              </span>
                            )}
                          </div>
                        </div>
                      )}

                      <div className="col-xl-6 col-sm-6">
                        <div className="mb-3">
                          <label className="form-label">
                            Admission Date
                            <span className="text-danger"> *</span>
                          </label>
                          <input
                            className="form-control"
                            type="date"
                            value={adate}
                            onChange={(e) => setADate(e.target.value)}
                            onKeyPress={(event) => {
                              event.preventDefault();
                            }}
                            onKeyDown={(event) => {
                              event.preventDefault();
                            }}
                          />
                          {successmsg && adate === "" && (
                            <span className="text-danger">
                              Please Select Admission Date
                            </span>
                          )}
                        </div>
                      </div>
                      <div className="col-xl-6 col-sm-6">
                        <div className="mb-3">
                          <label className="form-label">
                            Academic Year<span className="text-danger"> *</span>
                          </label>
                          <select
                            className="default-select  form-control wide"
                            value={ayear}
                            onChange={(e) => setAYear(e.target.value)}
                          >
                            <option value="" disabled>
                              Select Academic Year
                            </option>
                            {ylist.map((item, i) => {
                              return (
                                <option value={item.id} key={i}>
                                  {item.aca_year}
                                </option>
                              );
                            })}
                          </select>
                          {successmsg && ayear === "" && (
                            <span className="text-danger">
                              Please Enter Academic Year
                            </span>
                          )}
                        </div>
                      </div>
                      <div className="col-xl-6 col-sm-6">
                        <div className="mb-3">
                          <label className="form-label">
                            Class <span className="text-danger"> *</span>
                          </label>
                          <Select
                            className="default-select"
                            placeholder="Select Class"
                            value={sclass}
                            options={clslist}
                            onChange={handleClass}
                            isSearchable={true}
                            isClearable
                            hidden
                          />
                          {successmsg && sclass === "" && (
                            <span className="text-danger">
                              Please Select Class
                            </span>
                          )}
                        </div>
                      </div>
                      <div className="col-xl-6 col-sm-6">
                        <div className="mb-3">
                          <label className="form-label">
                            Section <span className="text-danger"> *</span>
                          </label>
                          <Select
                            className="default-select"
                            placeholder="Select Section"
                            value={studiv}
                            options={divlist}
                            onChange={handleDiv}
                            isSearchable={true}
                            isClearable
                            hidden
                          />
                          {successmsg && studiv === "" && (
                            <span className="text-danger">
                              Please Select Section
                            </span>
                          )}
                        </div>
                      </div>

                      <div className="col-xl-6 col-sm-6">
                        <div className="mb-3">
                          <label className="form-label">
                            Type <span className="text-danger"> *</span>
                          </label>
                          <select
                            className="default-select  form-control wide"
                            value={stutype}
                            onChange={(e) => setStuType(e.target.value)}
                          >
                            <option value="" disabled>
                              Select Type
                            </option>
                            <option value={1}>Day Scholar</option>
                            <option value={2}>Hosteller</option>
                            <option value={3}>Bus</option>

                          </select>
                          {successmsg && stutype === "" && (
                            <span className="text-danger">
                              Please Select Type
                            </span>
                          )}
                        </div>
                      </div>

                      {stutype == 3 &&
                        <>
                          <div className="col-xl-6 col-sm-6">
                            <div className="mb-3">
                              <label className="form-label">
                                Vehicle<span className="text-danger"> *</span>
                              </label>
                              <Select
                                className="default-select"
                                placeholder="Select Vehicle"
                                value={vehid}
                                options={vlist}
                                onChange={handleVehicle}
                                isSearchable={true}
                                isClearable
                                menuPortalTarget={document.body}
                                menuPosition="fixed"
                                styles={{ menuPortal: (base) => ({ ...base, zIndex: 9999 }) }}
                              />
                              {successmsg && vehid === "" && stutype == 3 && (
                                <span className="text-danger">
                                  Please Select Vehicle
                                </span>
                              )}
                            </div>
                          </div>

                          <div className="col-xl-6 col-sm-6">
                            <div className="mb-3">
                              <label className="form-label">
                                Stage  <span className="text-danger"> *</span>
                              </label>
                              <Select
                                className="default-select"
                                placeholder="Select Stage"
                                value={stgid}
                                options={stlist}
                                onChange={handleStage}
                                isSearchable={true}
                                isClearable
                                menuPortalTarget={document.body}
                                menuPosition="fixed"
                                styles={{ menuPortal: (base) => ({ ...base, zIndex: 9999 }) }}
                              />
                              {successmsg && stgid === "" && stutype == 3 && (
                                <span className="text-danger">
                                  Please Select Stage
                                </span>
                              )}
                            </div>
                          </div>

                          <div className="col-xl-6 col-sm-6">
                            <div className="mb-3">
                              <label className="form-label">
                                Trip
                              </label>
                              <Select
                                isMulti
                                className="default-select"
                                placeholder="Select Trip"
                                value={tripsel}
                                options={trlist}
                                onChange={handleTrip}
                                isSearchable={true}
                                isClearable
                                menuPortalTarget={document.body}
                                menuPosition="fixed"
                                styles={{ menuPortal: (base) => ({ ...base, zIndex: 9999 }) }}
                              />
                            </div>
                          </div>
                        </>

                      }
                      <div className="col-xl-6 col-sm-6">
                        <div className="mb-3">
                          <label className="form-label">
                            Admission No<span className="text-danger"> *</span>
                          </label>
                          <input
                            type="text"
                            className="form-control"
                            placeholder="Enter Admission Number"
                            value={admno}
                            onChange={(e) => setAdmNo(e.target.value)}
                          />
                          {successmsg && admno === "" && (
                            <span className="text-danger">
                              Please Enter Admission Number
                            </span>
                          )}
                        </div>
                      </div>
                      <div className="col-xl-6 col-sm-6">
                        <div className="mb-3">
                          <label className="form-label">
                            Roll Number<span className="text-danger"> *</span>
                          </label>
                          <input
                            type="text"
                            className="form-control"
                            placeholder="Enter Roll Number"
                            value={rollno}
                            onChange={(e) => setRollNo(e.target.value)}
                          />
                          {successmsg && rollno === "" && (
                            <span className="text-danger">
                              Please Enter Roll Number
                            </span>
                          )}
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            {errmsg !== "" && <span className="text-danger">{errmsg}</span>}
            <div className="res-right mt-2 me-4">
              {urllink === "addstudents" && (
                <button className="btn btn-success" onClick={submitstu}>
                  Submit
                </button>
              )}
              {urllink !== "addstudents" && (
                <>
                  <button className="btn btn-success me-2" onClick={submitstu}>
                    Update
                  </button>
                  <button
                    className="btn btn-secondary"
                    onClick={() => navigate(-1)}
                  >
                    Back
                  </button>
                </>
              )}
            </div>
          </div>
        </div>
      )}
    </div>
  );
}
